export default "__VITE_ASSET__D1mp6z7V__"